/**
 * Bibliothèque Problème métier → Template Expert.
 * Source : TaleScan V0.5, §4 et §6 (Univers/Domaines + Problèmes métier).
 * Volontairement statique : cette liste est censée rester "peu nombreuse et
 * stable" (V0.5 §12) — on migrera vers une source distante seulement si la
 * gouvernance des templates l'exige.
 *
 * Display copy (question/templateName) lives in src/locales/{en,fr,ar}.json
 * under surveyBuilder.taleScan.problems.items.<problemId> — not here, since
 * translations aren't available at module scope. Resolve it via
 * getProblemLabels(problemId, t) from a component that has already called
 * useTranslation().
 */
export const taleScanDomains = {
  marketing: 'Marketing / Consumer Insights',
  rh: 'RH / Employee Insights',
  b2b: 'B2B / Business Insights',
  opinion: 'Opinion publique / Public Insights',
  innovation: 'Innovation',
  evaluation: 'Évaluation / Programmes / Projets',
  communication: 'Communication / Institutionnel',
};

export const taleScanProblems = [
  {
    problemId: 'buying',
    domainId: 'marketing',
    status: 'PUBLISHED',
    category: 'GENERAL_MARKET_RESEARCH',
  },
  {
    problemId: 'brand',
    domainId: 'marketing',
    status: 'DRAFT',
    category: 'BRAND_TRACKING_OR_AWARENESS',
  },
  { problemId: 'customer-experience', domainId: 'marketing', status: 'DRAFT' },
  { problemId: 'satisfaction', domainId: 'marketing', status: 'DRAFT' },
  { problemId: 'usage', domainId: 'marketing', status: 'DRAFT' },
  { problemId: 'loyalty', domainId: 'marketing', status: 'DRAFT' },
  { problemId: 'price', domainId: 'marketing', status: 'DRAFT' },
  { problemId: 'concept', domainId: 'marketing', status: 'DRAFT' },

  // RH / Employee
  { problemId: 'rh-employee-experience', domainId: 'rh', status: 'DRAFT' },
  { problemId: 'rh-engagement', domainId: 'rh', status: 'DRAFT' },
  { problemId: 'rh-employee-satisfaction', domainId: 'rh', status: 'DRAFT' },
  { problemId: 'rh-motivation', domainId: 'rh', status: 'DRAFT' },
  { problemId: 'rh-onboarding', domainId: 'rh', status: 'DRAFT' },
  { problemId: 'rh-training', domainId: 'rh', status: 'DRAFT' },
  { problemId: 'rh-internal-communication', domainId: 'rh', status: 'DRAFT' },
  { problemId: 'rh-retention', domainId: 'rh', status: 'DRAFT' },

  // B2B / Business
  { problemId: 'b2b-needs', domainId: 'b2b', status: 'DRAFT' },
  { problemId: 'b2b-buying-process', domainId: 'b2b', status: 'DRAFT' },
  { problemId: 'b2b-decision-makers', domainId: 'b2b', status: 'DRAFT' },
  { problemId: 'b2b-supplier-selection', domainId: 'b2b', status: 'DRAFT' },
  { problemId: 'b2b-customer-experience', domainId: 'b2b', status: 'DRAFT' },
  { problemId: 'b2b-satisfaction', domainId: 'b2b', status: 'DRAFT' },
  { problemId: 'b2b-retention', domainId: 'b2b', status: 'DRAFT' },
  { problemId: 'b2b-value-proposition', domainId: 'b2b', status: 'DRAFT' },

  // Opinion publique / Public
  { problemId: 'opinion-opinion', domainId: 'opinion', status: 'DRAFT' },
  { problemId: 'opinion-perception', domainId: 'opinion', status: 'DRAFT' },
  { problemId: 'opinion-trust', domainId: 'opinion', status: 'DRAFT' },
  { problemId: 'opinion-priorities', domainId: 'opinion', status: 'DRAFT' },
  { problemId: 'opinion-intentions', domainId: 'opinion', status: 'DRAFT' },
  { problemId: 'opinion-satisfaction', domainId: 'opinion', status: 'DRAFT' },
  { problemId: 'opinion-awareness', domainId: 'opinion', status: 'DRAFT' },
  { problemId: 'opinion-acceptability', domainId: 'opinion', status: 'DRAFT' },

  // Innovation
  { problemId: 'innovation-need-validation', domainId: 'innovation', status: 'DRAFT' },
  { problemId: 'innovation-concept-evaluation', domainId: 'innovation', status: 'DRAFT' },
  { problemId: 'innovation-adoption', domainId: 'innovation', status: 'DRAFT' },
  { problemId: 'innovation-barriers', domainId: 'innovation', status: 'DRAFT' },
  { problemId: 'innovation-feature-prioritization', domainId: 'innovation', status: 'DRAFT' },
  { problemId: 'innovation-value-proposition', domainId: 'innovation', status: 'DRAFT' },

  // Évaluation / Programmes / Projets
  { problemId: 'evaluation-needs-assessment', domainId: 'evaluation', status: 'DRAFT' },
  { problemId: 'evaluation-relevance', domainId: 'evaluation', status: 'DRAFT' },
  { problemId: 'evaluation-satisfaction', domainId: 'evaluation', status: 'DRAFT' },
  { problemId: 'evaluation-beneficiary-experience', domainId: 'evaluation', status: 'DRAFT' },
  { problemId: 'evaluation-effectiveness', domainId: 'evaluation', status: 'DRAFT' },
  { problemId: 'evaluation-accessibility', domainId: 'evaluation', status: 'DRAFT' },
  { problemId: 'evaluation-impact-perception', domainId: 'evaluation', status: 'DRAFT' },
  { problemId: 'evaluation-improvement-priorities', domainId: 'evaluation', status: 'DRAFT' },

  // Communication / Institutionnel
  { problemId: 'communication-message-testing', domainId: 'communication', status: 'DRAFT' },
  { problemId: 'communication-campaign-evaluation', domainId: 'communication', status: 'DRAFT' },
  { problemId: 'communication-recall', domainId: 'communication', status: 'DRAFT' },
  { problemId: 'communication-channel-effectiveness', domainId: 'communication', status: 'DRAFT' },
  { problemId: 'communication-credibility', domainId: 'communication', status: 'DRAFT' },
  { problemId: 'communication-engagement', domainId: 'communication', status: 'DRAFT' },
];

export const getProblemById = (problemId) =>
    taleScanProblems.find((p) => p.problemId === problemId) ?? null;

/**
 * Resolves a problem's display copy in the caller's current UI language.
 * `t` must come from the calling component's own useTranslation() — these
 * labels aren't resolvable at module scope.
 */
export const getProblemLabels = (problemId, t) => ({
  question: t(`surveyBuilder.taleScan.problems.items.${problemId}.question`),
  templateName: t(`surveyBuilder.taleScan.problems.items.${problemId}.templateName`),
});

/**
 * Banque de questions core par problème métier, avec type de réponse et
 * options — prête à être mappée sur le payload de création de survey réel
 * une fois ce mapping connu (cf. handleSelect dans TaleScanDashboard.jsx).
 *
 * BUYING : source Tale_Scan_AI_TaleCraft Specification §9.
 * BRAND  : source Modèle_Brand_Perception.docx fourni par le client
 *          (jeu de questions n°2 du document, celui avec un "Type : ..."
 *          explicite sur chaque question — l'autre jeu du même doc n'a pas
 *          de type annoté). À confirmer avec le client si ce n'était pas
 *          le jeu voulu.
 * Tout le reste de la bibliothèque n'a pas encore de contenu réel — un
 * template DRAFT sans banque ici démarre une survey sans questions
 * pré-remplies plutôt que de planter.
 *
 * Fixed French on purpose, unlike question/templateName above: this is the
 * client's own authored survey content (verbatim from their documents), not
 * dashboard UI copy — it must not shift with the visitor's UI language.
 */
const CORE_QUESTIONS_BY_PROBLEM = {
  buying: [
    { text: 'À quelle fréquence achetez-vous {product} ?', responseType: 'single_choice' },
    { text: 'Quels critères influencent votre choix de {product} ?', responseType: 'multiple_choice' },
    { text: 'Quelles marques de {product} achetez-vous habituellement ?', responseType: 'multiple_choice' },
    { text: 'Quelle est la principale raison de choisir une marque de {product} ?', responseType: 'single_choice' },
    { text: 'Qu’est-ce qui peut vous empêcher d’acheter cette marque ?', responseType: 'multiple_choice' },
    { text: 'Comment percevez-vous son niveau de prix ?', responseType: 'scale' },
    { text: 'Quelle est votre intention d’achat ?', responseType: 'scale' },
    { text: 'Qu’est-ce qui pourrait vous convaincre ?', responseType: 'multiple_choice' },
  ],
  brand: [
    {
      // Q1
      text: 'Connaissiez-vous {product} avant ce sondage ?',
      responseType: 'single_choice',
      options: [
        'Je la connais bien et je l’utilise',
        'Je la connais mais je ne l’utilise pas',
        'J’en ai entendu parler, sans plus',
        'Je ne la connaissais pas avant ce sondage',
      ],
    },
    // Q2 — type "matrice" dans le doc client (4 lignes, échelle 1-5 partagée) :
    // pas de format "matrice" dans l'app, éclaté en 4 questions star (1-5)
    // séparées, description = les deux pôles de l'axe. À revoir si un vrai
    // type matrice existe côté backend.
    {
      text: 'Comment situez-vous {product} sur l’axe : Traditionnelle (1) → Moderne (5) ?',
      responseType: 'rating_1_5',
    },
    {
      text: 'Comment situez-vous {product} sur l’axe : Peu fiable (1) → Fiable (5) ?',
      responseType: 'rating_1_5',
    },
    {
      text: 'Comment situez-vous {product} sur l’axe : Distante (1) → Proche des gens (5) ?',
      responseType: 'rating_1_5',
    },
    {
      text: 'Comment situez-vous {product} sur l’axe : Peu innovante (1) → Innovante (5) ?',
      responseType: 'rating_1_5',
    },
    {
      // Q3
      text: 'Dans quelle mesure {product} vous paraît-elle différente de ses concurrents ?',
      responseType: 'single_choice',
      options: [
        'Très différente', 'Assez différente', 'Moyennement différente',
        'Peu différente', 'Pas du tout différente',
        'Je ne connais pas assez les autres marques pour comparer',
      ],
    },
    {
      // Q4 — réaction instinctive par émojis
      text: 'Quelle est votre réaction instinctive en pensant à {product} ?',
      responseType: 'emoji_scale',
    },
    {
      // Q5
      text: 'Selon vous, quelle est la principale force de {product} ?',
      responseType: 'single_choice_other',
      options: [
        'La qualité de ses produits/services', 'Son prix ou son rapport qualité-prix',
        'Son service client ou son accompagnement', 'Sa réputation ou la confiance qu’elle inspire',
        'Sa proximité ou son accessibilité', 'Autre',
      ],
    },
    {
      // Q6 révisée
      text: 'Si vous deviez résumer {product} en une seule expression, laquelle choisiriez-vous ?',
      responseType: 'single_choice',
      options: [
        'Une marque de confiance', 'Une marque innovante', 'Une marque accessible',
        'Une marque haut de gamme', 'Une marque proche des gens',
        'Une marque comme une autre, sans particularité',
      ],
    },
    {
      // Q7
      text: 'Sur une échelle de 0 à 10, quelle est la probabilité que vous recommandiez {product} à un proche ?',
      responseType: 'scale',
    },
    {
      // Q8
      text: 'Si vous pouviez changer ou améliorer une seule chose concernant {product}, laquelle serait-ce ?',
      responseType: 'open_text',
    },
  ],
};

const contextualize = (question, context) => ({
  ...question,
  text: question.text.replace('{product}', context?.product?.trim() || 'ce produit/service'),
});

/**
 * Renvoie la banque de questions core pour un problème, contextualisée.
 * Synchrone (plus de mock avec délai — la vraie création de survey portera
 * l'asynchronicité côté API). Renvoie [] si le template n'a pas encore de
 * contenu réel, pour démarrer une survey vide plutôt que planter.
 */
export const getCoreQuestions = (problemId, context = {}) => {
  const bank = CORE_QUESTIONS_BY_PROBLEM[problemId] ?? [];
  return bank.map((q) => contextualize(q, context));
};

/**
 * Maps our template question shape onto the real survey question shape
 * consumed by CreateSurveyLayout / CreateSurveyStep2 (question_text,
 * format, possible_responses, responseType — see isQuestionGood in
 * survey/new/scratch/index.jsx).
 *
 * format enum: "1-10" | "smile" | "star" | "comment" | "checkbox" | "radio"
 * responseType here means question MEDIA type (TEXT/IMAGE/VIDEO/SOUND),
 * not the answer type — always TEXT for TaleScan-generated questions.
 *
 * IMPORTANT: Buying's single_choice/multiple_choice questions don't have
 * real option text yet (the client's Buying doc only gave the question
 * title, no answer list — cf. taleScanProblems.js note above). Rather than
 * invent plausible-sounding options, those fall back to "comment" (open
 * text) until real options exist — flagged, not silently guessed.
 */
const RESPONSE_TYPE_TO_FORMAT = {
  single_choice: 'radio',
  multiple_choice: 'checkbox',
  single_choice_other: 'radio',
  rating_1_5: 'star',
  scale: '1-10',
  emoji_scale: 'smile',
  open_text: 'comment',
};

export const toSurveyQuestion = (question) => {
  const needsOptions = ['radio', 'checkbox'].includes(RESPONSE_TYPE_TO_FORMAT[question.responseType]);
  const hasOptions = Array.isArray(question.options) && question.options.length > 0;
  const format = needsOptions && !hasOptions ? 'comment' : RESPONSE_TYPE_TO_FORMAT[question.responseType] ?? 'comment';

  return {
    id: crypto.randomUUID(),
    question_text: question.text,
    format,
    responseType: 'TEXT',
    possible_responses: format === 'radio' || format === 'checkbox' ? question.options : [],
    assets: [],
  };
};
